import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
// Replace these values with your Firebase project config
const firebaseConfig = {
    apiKey: "AIzaSyCr0vb9fLTvGd8kpZJMnUNBDww9BHOQveQ",
    authDomain: "mtu-alums.firebaseapp.com",
    projectId: "mtu-alums",
    storageBucket: "mtu-alums.firebasestorage.app",
    messagingSenderId: "555996959968",
    appId: "1:555996959968:web:7dae4366010086798a6c85",
    measurementId: "G-3WDNP6V9QP"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

export default app;

